window.TrackData = null
import commonB from "@/assets/js/common-addition.js"
import {
  TconvertLngLat,
  dblCilckEvent,
} from "../common"
import store from '../../../store/index'
import {
  AddGeoLock,
  DeleteGeoLock,
  AddGeoLockBatch,
  DeleteGeoLockBatch
} from "../../api/feature"
import {
  Message,
  MessageBox
} from 'element-ui'
export function sortUnionDataInfo(list) {
  let ilist = []
  list.sort(function (a, b) {
    return a.GDataId - b.GDataId
  })
  for (let i = 0; i < list.length;) {
    let temp = list[i].GDataId
    let templist = []
    do {
      templist.push(list[i].Id)
      i++
    } while (i < list.length && list[i].GDataId == temp)
    ilist.push({
      GDataId: temp,
      ids: templist
    })
    templist = []
  }
  return ilist
}
//获取shapes
export function GetGeoShape(gra) {
  let Dgeometry = gra.geometry
  let coordinate = parseInt(gra.attributes.selectLayer.coordinate)
  Dgeometry = TconvertLngLat(coordinate, Dgeometry)
  let Shape = "";
  if (Dgeometry.type == "point") {
    Shape = [Dgeometry.x, Dgeometry.y]
  } else if (Dgeometry.type == "polyline") {
    Shape = Dgeometry.paths
  } else if (Dgeometry.type == "polygon") {
    Shape = Dgeometry.rings
  }
  return Shape;
}
//获取 extent
export function getOriginalExtent(graphics) {
  let geometry = graphics.geometry
  let coordinate = parseInt(graphics.attributes.selectLayer.coordinate)
  geometry = TconvertLngLat(coordinate, geometry)
  if (geometry.type == "point") {
    return geometry.x + "," + geometry.y
  } else {
    let extent = geometry.getExtent()
    let eArr = []
    eArr.push(extent.xmin)
    eArr.push(extent.ymin)
    eArr.push(extent.xmax)
    eArr.push(extent.ymax)
    return eArr.join(',')
  }
}
//归类排序
export function sortDataInfo(list) {
  let ilist = []
  list.sort(function (a, b) {
    return a.gdataid - b.gdataid
  })
  for (let i = 0; i < list.length;) {
    let temp = list[i].gdataid
    let templist = []
    do {
      templist.push(list[i].gdatadata)
      i++
    } while (i < list.length && list[i].gdataid == temp)
    ilist.push({
      gdataid: temp,
      gdatadata: templist
    })
    templist = []
  }
  return ilist
}
//圆弧边上一点到圆的最近距离和垂足点
//center:圆心  pt:点  radius:半径 返回切点坐标和点到圆的最近距离
export function tangentPointCoor(center, pt, radius) {
  radius = parseFloat(radius)
  let dd = pt.x - center.x
  let yy = pt.y - center.y
  let l = radius - Math.sqrt(Math.pow(dd, 2) + Math
    .pow(yy, 2))
  let direction = Math.atan2(dd, yy)
  let points = {
    x: pt.x,
    y: pt.y
  }
  if (l == 0) {
    points = {
      x: pt.x,
      y: pt.y
    }
  } else {
    let x = parseFloat(pt.x + l * Math.sin(direction))
    let y = parseFloat(pt.y + l * Math.cos(direction))
    points = {
      x: x,
      y: y
    }
  }
  let dist = Math.sqrt(Math.pow((pt.x - points.x), 2) + Math.pow((pt.y - points.y), 2))
  if (l < 0) {
    dist = -dist
  }
  return {
    point: points,
    dist: dist
  }
}
export function GetNearstPoint(fromPoint, PointList, val) {
  for (var i = 0; i < PointList.length; i++) {
    var d1 = Math.pow(
      Math.pow(fromPoint.x - PointList[i][0], 2) +
      Math.pow(fromPoint.y - PointList[i][1], 2),
      0.5
    );
    if (d1 < val) {
      return PointList[i];
      break;
    }
  }
  return null;
}
//判断是否带有弧线
export function Arcjudge(geo) {
  let arcline = store.state.arcLineArr
  let onj = arcline.find(x => x.featureId == geo.attributes.ID && x.layerId == parseInt(geo.attributes.selectLayer.layerId))
  if (onj == undefined || onj == null) {
    return {
      code: false,
      index: -1
    }
  } else {
    let index = arcline.findIndex(x => x.featureId == geo.attributes.ID && x.layerId == parseInt(geo.attributes.selectLayer.layerId))
    return {
      code: true,
      index: index,
      data: onj
    }
  }
}
//高亮颜色
export function getHighlightSymbol(geometry) {
  let esriModule = store.state.esriModule;
  let symbol = null
  if (geometry.type == "point") {
    symbol = new esriModule.SimpleMarkerSymbol(
      esriModule.SimpleMarkerSymbol.STYLE_CIRCLE,
      16,
      new esriModule.SimpleLineSymbol(
        esriModule.SimpleLineSymbol.STYLE_SOLID,
        new esriModule.Color([255, 255, 0]),
        1
      ),
      new esriModule.Color([255, 0, 0, 0.8])
    );
  } else if (geometry.type == "polyline") {
    symbol = new esriModule.SimpleLineSymbol(
      esriModule.SimpleLineSymbol.STYLE_SOLID,
      new esriModule.Color([255, 0, 0, 1]),
      8
    )
  }
  return symbol;

}

//取切片图形的节点数据
export function gettempScreenData(params) {
  let obj = tempScreenData.find(x => x.layerId == params.layerId && x.ID == params.ID)
  if (obj != undefined) {
    return obj
  } else {
    return null
  }
}
//存切片图形的节点数据
export function savetempScreenData(obj) {
  tempScreenData.push(obj)
  //暂时支持存100个
  if (tempScreenData.length == 100) {
    tempScreenData.splice(0, 1)
  }
}
//真实节点
export function saveRealData(obj) {
  let index = realNode.findIndex(x => x.layerId == obj.layerId && x.ID == obj.ID)
  if (index != -1) {
    realNode.splice(index, 1)
    realNode.push(obj)
    let d = tempScreenData.findIndex(x => x.layerId == obj.layerId && x.ID == obj.ID)
    if (d != -1) {
      tempScreenData.splice(d, 1)
    }
    savetempScreenData(obj)
  } else {
    realNode.push(obj)
    savetempScreenData(obj)
  }
}
export function getRealData(params) {
  let obj = realNode.find(x => x.layerId == params.layerId && x.ID == params.ID)
  if (obj != undefined) {
    return obj
  } else {
    return null
  }
}
//解压转字符串
export function unzip(b64Data) {
  var charData = b64Data.split("").map(function (x) {
    return x.charCodeAt(0);
  });
  var data = pako.inflate(new Uint8Array(charData));
  var array = new Uint16Array(data);
  var strData = ""
  strData = Utf8ArrayToStr(array);
  return strData;
}

function Utf8ArrayToStr(array) { // 数据流转化为字符串, 兼容汉字
  var out = "",
    i = 0,
    len = array.length,
    char1, char2, char3, char4;
  while (i < len) {
    char1 = array[i++];
    // 当单个字节时, 最大值 '01111111', 最小值 '00000000' 右移四位 07, 00
    // 当两个字节时, 最大值 '11011111', 最小值 '11000000' 右移四位 13, 12
    // 当三个字节时, 最大值 '11101111', 最小值 '11100000' 右移四位 14, 14
    if (char1 >> 4 <= 7) {
      out += String.fromCharCode(char1);
    } else if (char1 >> 4 == 12 || char1 >> 4 == 13) {
      char2 = array[i++];
      out += String.fromCharCode(((char1 & 0x1F) << 6) | (char2 & 0x3F));
    } else if (char1 >> 4 == 14) {
      char2 = array[i++];
      char3 = array[i++];
      char4 = ((char1 & 0x0F) << 12) | ((char2 & 0x3F) << 6);
      out += String.fromCharCode(char4 | ((char3 & 0x3F) << 0));
    }
  }
  // console.log(999, out)
  return out;

};
//锁定要素
export function lockGeometry(arr) {
  let dlist = []
  let i = 0
  let obj = []
  let GDataId = []
  arr.forEach(item => { //layerId:图层ID,ID:要素ID
    let index = lockData.findIndex(x => x.layerId == item.layerId && x.ID == item.ID)
    if (index == -1) {
      lockData.push(item)
    }
    let o = store.state.allLayerData.find(x => x.Id == item.layerId)
    if (GDataId.indexOf(o.GDataId) == -1) {
      GDataId.push(o.GDataId)
    }
    dlist.push(item.ID)
    obj.push({
      GDataId: o.GDataId,
      Id: item.ID
    })
    i++
  })
  if (i == 1) {
    AddGeoLock({
      "gDataId": GDataId[0],
      "userId": store.state.user.mapUserId,
      "id": dlist[0]
    }).then(res => {
      console.log("AddGeoLock", res.data)
      unlockClock()
    })
  } else {
    if (GDataId.length == 1) {
      AddGeoLockBatch({
        "gDataId": GDataId[0],
        "userId": store.state.user.mapUserId,
        "iDs": dlist
      }).then(res => {
        console.log("AddGeoLockBatch", res.data)
        unlockClock()
      })
    } else {
      let list = sortlockData(obj)
      list.forEach(item => {
        AddGeoLockBatch({
          "gDataId": item.GDataId,
          "userId": store.state.user.mapUserId,
          "iDs": item.ids
        }).then(res => {
          console.log("AddGeoLockBatch", res.data)
          unlockClock()
        })
      })
    }

  }
}
//解锁要素
export function unlockGeometry(arr) {
  let dlist = []
  let obj = []
  let GDataId = []
  let i = 0
  arr.forEach(item => {
    let index = lockData.findIndex(x => x.layerId == item.layerId && x.ID == item.ID)
    if (index != -1) {
      lockData.splice(index, 1)
      let o = store.state.allLayerData.find(x => x.Id == item.layerId)
      if (GDataId.indexOf(o.GDataId) == -1) {
        GDataId.push(o.GDataId)
      }
      dlist.push(item.ID)
      obj.push({
        GDataId: o.GDataId,
        Id: item.ID
      })
    }
    i++
  })
  if (i == 1) {
    DeleteGeoLock({
      "gDataId": GDataId[0],
      "userId": store.state.user.mapUserId,
      "id": dlist[0]
    }).then(res => {
      console.log("DeleteGeoLock", res.data)
    })
  } else {
    if (GDataId.length == 1) {
      DeleteGeoLockBatch({
        "gDataId": GDataId[0],
        "userId": store.state.user.mapUserId,
        "iDs": dlist
      }).then(res => {
        console.log("DeleteGeoLockBatch", res.data)
      })
    } else {
      let list = sortlockData(obj)
      list.forEach(item => {
        DeleteGeoLockBatch({
          "gDataId": item.GDataId,
          "userId": store.state.user.mapUserId,
          "iDs": item.ids
        }).then(res => {
          console.log("DeleteGeoLockBatch", res.data)
        })
      })
    }

  }
}

function sortlockData(list) {
  let ilist = []
  list.sort(function (a, b) {
    return a.GDataId - b.GDataId
  })
  for (let i = 0; i < list.length;) {
    let temp = list[i].GDataId
    let templist = []
    do {
      templist.push(list[i].Id)
      i++
    } while (i < list.length && list[i].GDataId == temp)
    ilist.push({
      GDataId: temp,
      ids: templist
    })
    templist = []
  }
  return ilist
}
//是否可强制解锁
export function forceUnlockGeometry(red, obj) {
  let data = JSON.parse(red.data.Data)
  if (!data.IsUnLock) {
    Message({
      message: "该要素被锁定，暂时不可编辑",
      type: "warning",
      duration: 2000,
      offset: 350
    })
  } else {
    MessageBox.confirm("该要素被锁定，是否强制解锁？", '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      showCancelButton: true,
      closeOnClickModal: false,
      type: 'warning',
      customClass: "MessageModel"
    }).then(() => {
      DeleteGeoLock({
        "gDataId": obj.gDataId,
        "userId": store.state.user.mapUserId,
        "id": obj.id
      }).then(res => {
        if (res.data.Status == 1) {
          Message({
            message: "强制解锁成功",
            type: "success",
            duration: 2000,
            offset: 350
          })
        } else {
          Message({
            message: "强制解锁失败",
            type: "warning",
            duration: 2000,
            offset: 350
          })
        }

      })

    }).catch(() => {})
  }
}
//是否显示要素溯源
export function isTrackSourceShow(evt) {
  TrackData = null
  let data = dblCilckEvent(evt)
  if (data != null) {
    let o = store.state.allLayerData.find(x => x.Id == data.layerId)
    if (o.Executor == store.state.user.mapUserId) {
      TrackData = {
        "gDataId": o.GDataId,
        "id": data.Id,
        "userId": store.state.user.mapUserId,
        "layerId": data.layerId,
        "LayerName": o.LayerName,
        "geoType": o.GeoType,
        "coordinate": o.coordinate
      }
      return true;
    } else {
      return false
    }
  }
  return false;

}
///定时解锁
export function unlockClock() {
  clearInterval(lockkclock)
  lockkclock = setInterval(function () {
    unlock()
  }, 60000)
}

export function unlock() {
  tb.deactivate();
  tb2.deactivate();
  map.setMapCursor("default");
  isDrawing = false;
  IsToolActive = false;
  map.enablePan()
  map.enableScrollWheel()
  store.dispatch("setOperation", "可右键点击切换到地图漫游状态")
  if (TempLightlingLayer != null) {
    TempLightlingLayer.clear();
    store.commit("set_nodeObj", null)
    SnapingGraphic = null
  }
  current_tool = null
  selectNodes = []
  offset_movepolygon = null
  commonB.removeMoveCanvas()
  editTool.deactivate();
  if (lockData.length > 0) {
    unlockGeometry(lockData)
  }
}
